export default __webpack_public_path__ + "static/media/menuL_icon_08.efc3031e.png";